<template>
  <transition name="fade">
    <div class="scroll-to-top" v-show="showScrollToTopButton">
      <OrangeFancyButton
        class="scroll-to-top__button"
        @click="handleClick"
      >
        <div class="scroll-to-top__content">
          <transition name="slide-fade" mode="out-in">
            <span class="scroll-to-top__button-icon" v-if="buttonStyle === 'icon'" key="icon">
              <RightArrow color="#EB883B" />
            </span>
            <span class="scroll-to-top__button-text" v-else key="text">На початок сторінки</span>
          </transition>
        </div>
      </OrangeFancyButton>
    </div>
  </transition>
</template>

<script>
import { scrollToTop, trackScroll } from '@/shared/lib/scroll';
import { OrangeFancyButton } from '@/shared/ui/form';
import { RightArrow } from '@/shared/ui/icons';

export default {
  props: {
    threshold: {
      type: Number,
      default: 100,
    },
    animationTime: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      showScrollToTopButton: false,
      buttonStyle: 'icon',
      animationTimer: null,
    };
  },
  created() {
    this.subscribeToScroll((position) => this.showScrollToTopButton = position.top >= this.threshold);
    this.animationTimer = setInterval(() => {
      if (this.buttonStyle === 'icon') {
        this.buttonStyle = 'text';
        return;
      }

      this.buttonStyle = 'icon';
    }, this.animationTime * 1000);
  },
  beforeDestroy() {
    clearInterval(this.animationTimer);
  },
  methods: {
    handleClick() {
      this.showScrollToTopButton = false;
      this.$nextTick(() => {
        this.scrollToTop();
      });
    }
  },
  mixins: [ scrollToTop, trackScroll ],
  components: { OrangeFancyButton, RightArrow },
};
</script>

<style lang="scss" scoped>
.scroll-to-top {
  &__content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  &__button-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    border-radius: 50%;
    transform: rotate(-90deg);
  }

  &__button-text {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Inter', sans-serif;
    font-size: 9px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    width: 32px;
    margin: -5px 0;
  }
}

::v-deep .orange-fancy-button__content {
  padding: 13px !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-in;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

// Alternative cross-fade animation (uncomment to use instead of slide-fade)
/*
.cross-fade-enter-active, .cross-fade-leave-active {
  transition: opacity 0.3s ease;
  position: absolute;
  left: 0;
  right: 0;
}

.cross-fade-enter, .cross-fade-leave-to {
  opacity: 0;
}
*/
</style>
